import React, { useState, useEffect } from "react";
import audioPlayer from "../services/audioPlayer";
import "./AudioPlayer.css";

const AudioPlayer = ({ text, autoPlay = true }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);

  useEffect(() => {
    audioPlayer.setOnPlayStateChange((state) => {
      setIsSpeaking(state.isSpeaking);
    });
    return () => audioPlayer.setOnPlayStateChange(null);
  }, [hasPlayed]);

  useEffect(() => {
    if (text && autoPlay && !hasPlayed) handlePlay();
  }, [text, autoPlay]);

  const handlePlay = () => {
    if (!text) return;
    setShowControls(true);
    setHasPlayed(true);
    audioPlayer.playText(text);
  };

  const handleStop = () => {
    audioPlayer.stop();
    setShowControls(false);
  };

  if (!text) return null;

  return (
    <div className={`audio-player ${showControls ? "visible" : ""}`}>
      <button
        className="audio-toggle-btn"
        onClick={() => showControls ? handleStop() : handlePlay()}
        title={isSpeaking ? "Stop speaking" : "Play Veritas voice"}
      >
        {isSpeaking ? <i className="fas fa-volume-up"></i> : <i className="fas fa-volume"></i>}
      </button>
      {showControls && (
        <div className="audio-controls">
          <div className="audio-waveform">
            {[0,1,2,3,4].map(i => (
              <span key={i} className={`wave-bar ${isSpeaking ? "active" : ""}`}></span>
            ))}
          </div>
          <button className="audio-btn" onClick={handleStop} title="Stop">
            <i className="fas fa-stop"></i>
          </button>
          <span className="audio-label">{isSpeaking ? "Speaking..." : "Paused"}</span>
        </div>
      )}
    </div>
  );
};

export default AudioPlayer;
